import { render, staticRenderFns } from "./TuesdayTalks.vue?vue&type=template&id=83eed808&scoped=true"
import script from "./TuesdayTalks.vue?vue&type=script&lang=js"
export * from "./TuesdayTalks.vue?vue&type=script&lang=js"
import style0 from "./TuesdayTalks.vue?vue&type=style&index=0&id=83eed808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83eed808",
  null
  
)

export default component.exports